import { useMemo, useEffect } from 'react';
import throttle from 'lodash/throttle';
import { useDeepEqualMemo } from '../useDeepEqualMemo';
/**
 * Returns a throttled version of the passed function.
 * Make sure your dep array is correct, linter doesn't work for custom hooks!!
 **/ export function useThrottle(func, dependencies, delay, options) {
    // memoize options so they don't throw off the throttle memo
    const memoizedOptions = useDeepEqualMemo(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttledFunction = useMemo(()=>throttle(func, delay, memoizedOptions), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...dependencies,
        delay,
        memoizedOptions
    ]);
    useEffect(()=>{
        return ()=>{
            throttledFunction.cancel();
        };
    }, [
        throttledFunction
    ]);
    return throttledFunction;
}

//# sourceMappingURL=useThrottle.js.map